<template>
    <search-collection :items="items" :sort-by="sortBy" :has-search="search" :pagination="pagination" :name="name" :description="description">
        <template slot-scope="{ item }">
            <slot :item="item"></slot>
        </template>
    </search-collection>
</template>
<script>
    import SearchCollection from './SearchCollection';
    export default {
        components: { SearchCollection },
        props: {
            name: {
                type: String,
                required: true,
            },
            description: {
                type: String,
                required: false,
            },
            items: {
                type: [Object, Array],
                default: () => [],
            },
            search: {
                type: Boolean,
                default: true,
            },
            pagination: {
                type: Boolean,
                default: false,
            },
            sortBy: {
                type: String,
                required: false,
            }
        }
    }
</script>
